import { render } from "./copyright_edit.vue?vue&type=template&id=71b0d62e&scoped=true"
import script from "./copyright_edit.vue?vue&type=script&lang=js"
export * from "./copyright_edit.vue?vue&type=script&lang=js"

import "./copyright_edit.vue?vue&type=style&index=0&id=71b0d62e&scoped=true&lang=css"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b0d62e"]])

export default __exports__